<template>
  <v-data-table
    v-model="selected"
    :headers="headers"
    :items="comments"
    item-key="id"
    show-select
  >
    <template v-slot:top>
      <v-dialog v-model="dialog" persistent max-width="390">
        <template v-slot:activator="{ on, attrs }">
          <div class="pb-4">コメント</div>
          <v-btn
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
          >
            チェックしたコメントを削除する
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="headline">確認</v-card-title>
          <v-card-text>
            選択されたコメントを削除します。よろしいですか？
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="deleteComments">OK</v-btn>
            <v-btn color="green darken-1" text @click="dialog = false">キャンセル</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>  
  </v-data-table>
</template>

<script>
  import mixin from '@/util/mixin'

  export default {
    mixins: [mixin],
    data () {
      return {
        dialog: false,
        reason: '11',
        db: null,
        selected: [],
        headers: [
          {
            text: 'ID',
            align: 'start',
            sortable: false,
            value: 'id',
          },
          { text: 'コメント日時', value: 'createdAt' },
          { text: '利用者', value: 'userName' },
          { text: '予想タイトル', value: 'predictionTitle' },
          { text: 'コメント', value: 'content' },
          { text: '返信', value: 'replyCount' },
          { text: 'いいね', value: 'likeCount' },
          { text: '通報', value: 'badCount' },
        ],
        comments: []
      }
    },
    methods: {
      deleteComments () {
        let promises = []
        for (const row of this.selected) {
          let promise = this.$fb.deleteDoc(this.$fb.doc(
            this.$fb.firestore,
            'prediction',
            row.predictionId,
            'comments',
            row.id
          ))
          promises.push(promise)
        }
        Promise.all(promises).then(() => {
          location.reload()
        }).catch (error => {
          console.error(error)
        })
      },
      getComments () {
        this.$fb.getDocs(this.$fb.query(this.$fb.collectionGroup(this.$fb.firestore, 'comments')
          .withConverter(this.commentsConverter),
          this.$fb.orderBy('created_at', 'desc'),
          this.$fb.limit(1000)))
          .then(commentSnap => {
            this.comments = []
            commentSnap.forEach(commentDoc => {
              let comment = commentDoc.data()
              comment.likeCount = comment.like?.length ?? 0
              comment.badCount = comment.bad?.length ?? 0
              comment.predictionId = commentDoc.ref.parent.parent.id
              const userPromise = this.$fb.getDoc(this.$fb.doc(
                this.$fb.firestore,
                'users',
                comment.userId)
                .withConverter(this.userConverter))
              const predictionPromise = this.$fb.getDoc(this.$fb.doc(
                this.$fb.firestore,
                'prediction',
                comment.predictionId)
                .withConverter(this.predictionConverter))
              const promiseArray = [
                userPromise,
                predictionPromise,
              ]
              Promise.all(promiseArray).then(resultArray => {
                const userDoc = resultArray[0]
                const predictionDoc = resultArray[1]
                comment.userName = userDoc.data()?.nickname
                comment.predictionTitle = predictionDoc.data().predictionTitle
                this.comments.push(comment)
              })
            })
          }).catch(error => {
            console.error(error)
            this.comments = []
          })
      },
    },
    created () {
      this.getComments()
    }
  }
</script>